import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://ku-assets-api-b1f2e83fc10c.herokuapp.com/api',
  headers: {
    Authorization:
      'Bearer 4a20100acc51f50939c58c42419c2acd74f41ea2eb3a2fec43aefd7bc38a58e8c9901f2b804d30557cc8f516bd0bb92c788341f78fd711ea9d78408abd69be9943e51ca8904f92dd24b3a992504a44bfc36d919b36895ebd70e7c5b6ad53579372de6c29c374c3f14e232d79e0ba85e8e8fc918a5549c0c7f456672b5cba86e1',
  },
});

export const getAssets = async (query) => {
  const param = query;
  try {
    const { data } = await instance.get(`/assets?${param}`);
    return data;
  } catch (error) {
    return error;
  }
};

export const CreateRequest = async (request) => {
  try {
    const { data } = await instance.post('/delete-requests', request);
    return data;
  } catch (error) {
    return error;
  }
};
export const CreateMoveRequest = async (request) => {
  try {
    const { data } = await instance.post('/move-requests', request);
    return data;
  } catch (error) {
    return error;
  }
};

export const getEmployees = async (query) => {
  try {
    const { data } = await instance.get(`/employees?${query}`);
    return data;
  } catch (error) {
    return error;
  }
};

export const createAssets = async (body) => {
  try {
    await instance.post('/request-assets', body);
    return true;
  } catch (error) {
    return error;
  }
};

export const uploadFile = async (submitData) => {
  try {
    const { data } = await instance.post('/upload', submitData);
    return data[0].id;
  } catch (error) {
    console.error('Error:', error);
    // Handle the error here
  }
};
